import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notes: [],
};

export const notesSlice = createSlice({
  name: "notes",
  initialState: { ...initialState },

  reducers: {
    /**
     * @name @setNotesToState
     * @description set notes to state
     **/
    setNotesToState: (state, action) => {
      if (action?.payload) state.notes = [...action?.payload];
    },
    /**
     * @name @setNoteToState
     * @description set a note to state
     **/
    setNoteToState: (state, action) => {
      const notesState = JSON.parse(JSON.stringify(state.notes));
      notesState.unshift(action.payload);
      state.notes = [...notesState];
    },
    /**
     * @name @setUpdatedNoteToState
     * @description set an updated note to state
     **/
    setUpdatedNoteToState: (state, action) => {
      let notesState = JSON.parse(JSON.stringify(state.notes));
      notesState = notesState.map((note) => {
        if (note.id === action.payload?.id) {
          note.note = action.payload?.note;
        }
        return note;
      });
      state.notes = [...notesState];
    },
  },
});

export const { setNotesToState, setNoteToState, setUpdatedNoteToState } =
  notesSlice.actions;

export const getNotes = (state) => {
  return state.notes?.notes;
};

export default notesSlice.reducer;
